import React, { FC } from 'react';

import { Container } from '@mui/material';
import cx from 'classnames';
import { Swiper, SwiperSlide } from 'swiper/react';
import { SwiperOptions } from 'swiper/types/swiper-options';

import { Background, QuotesListBlock } from '../../types';
import { LazyLoadImage } from '../LazyloadImage';
import { QuoteItem } from '../QuoteItem';
import useStyles from './styles';

const swiperSettings: SwiperOptions = {
  slidesPerView: 1,
  navigation: true,
  observer: true,
};

interface QuotesBlockProps {
  data: QuotesListBlock;
}

const QuotesBlock: FC<QuotesBlockProps> = ({ data }) => {
  const background = data?.background;
  const backgroundImage = data?.background_image;
  const items = data?.quotes || [];
  const isSingleQuoteBlock = items?.length === 1;

  const classes = useStyles(background, isSingleQuoteBlock)();

  return (
    <div
      className={cx(
        classes.wrapper,
        'quotes-block',
        !backgroundImage && (background === Background.Dark ? 'dark-block' : 'light-block'),
      )}
    >
      {backgroundImage && (
        <div className={cx(classes.imageWrapper, 'quotes-block__image-wrapper')}>
          <LazyLoadImage
            imageWrapperClass={classes.imageLazyloadWrapper}
            className={cx(classes.image, 'quotes-block__image')}
            path={backgroundImage}
            alt={'quotes'}
            sizes="100vw"
            draggable={false}
            data-testid="backgroundImage"
          />
        </div>
      )}
      <Container className={cx(isSingleQuoteBlock && classes.singleContainer)}>
        {isSingleQuoteBlock ? (
          <QuoteItem
            title={items[0]?.title}
            subtitle={items[0]?.sub_title}
            highLightColor={items[0]?.color_text}
            buttonLink={items[0]?.cta_button_link}
            buttonText={items[0]?.cta_button_text}
          />
        ) : (
          <Swiper {...swiperSettings}>
            {items.map((item, i) => (
              <SwiperSlide key={i}>
                <QuoteItem
                  title={item?.title}
                  subtitle={item?.sub_title}
                  isSingleItem={false}
                  highLightColor={item?.color_text}
                  buttonLink={item?.cta_button_link}
                  buttonText={item?.cta_button_text}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </Container>
    </div>
  );
};

export default QuotesBlock;
